module.exports = __webpack_public_path__ + "static/media/Klymit-Web-Destop-home.c4fdc3cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/Klymit/Klymit-Web-Destop-home.jpg
// module id = 595
// module chunks = 0